import { useOrganisationData } from '../../../../../../../../Hooks/useOrganisation';
import { useUserInfoData } from '../../../../../../../../Hooks/useUserInfo';

export default function useEnableSummary() {
  const userInfo = useUserInfoData();
  const org = useOrganisationData();

  if (!org.features.cogneedAi?.decisionTreeSummary?.enabled) {
    return false;
  }

  if (org.features.cogneedAi?.decisionTreeSummary?.staffOnly && !userInfo.isStaff) {
    return false;
  }

  return true;
}
